var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFGlasses1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 16,
    viewBox: "0 0 55 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6275 15C11.2392 15 7.72852 11.8539 7.72852 8C7.72852 4.14607 11.2392 1 15.6275 1C19.936 1 23.4466 4.14607 23.4466 8C23.4466 11.8539 19.936 15 15.6275 15Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9678 15C33.6593 15 30.1487 11.8539 30.1487 8C30.1487 4.14607 33.6593 1 37.9678 1C42.3561 1 45.8668 4.14607 45.8668 8C45.8668 11.8539 42.3561 15 37.9678 15Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5312 3.35961C21.5312 3.35961 26.877 -0.101064 32.3823 3.35961",
    stroke: "#1A1A1A",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5L1 4",
    stroke: "#1A1A1A",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 5L54.5 3.5",
    stroke: "#1A1A1A",
    strokeWidth: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFGlasses1);
export default __webpack_public_path__ + "static/media/f-glasses-1.760fa75248fe3c9e39726f6676fd0e56.svg";
export { ForwardRef as ReactComponent };